import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';

const modalRoot = document.getElementById('modal-root');

class Modal extends Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }

  componentDidMount() {
    modalRoot.appendChild(this.el);
    document.body.classList.toggle('no-overflow', true);
  }

  componentWillUnmount() {
    modalRoot.removeChild(this.el);
    document.body.classList.toggle('no-overflow', false);
  }

  render() {
    const { children } = this.props;
    return ReactDOM.createPortal(children, this.el);
  }
}

Modal.propTypes = {
  children: PropTypes.oneOfType([PropTypes.array, PropTypes.element]),
};

export default Modal;



// WEBPACK FOOTER //
// ./src/modules/pages/components/Modal.js